<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col>
					<multiselect v-model="departmentId" :options="departments" track-by="id" :show-labels="false"
						:allow-empty="true" :disabled="allDep" label="name" :placeholder="$t('pricing.department')"
						class="multiselect-pricing" />
					<!-- <b-checkbox v-model="allDep" switch>{{ $t("Whole_firm") }}</b-checkbox> -->
				</b-col>
				<b-col>
					<date-picker v-model="fromDate" lang="ru" style="width: 100%"
						:placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col>
					<date-picker v-model="toDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.toDate')"
						value-type="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col cols="2">
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-1" style="margin-top: -12px" />
					<b-button @click="print" variant="outline-dark" class="fa fa-print" style="margin-top: -10px" />
					<vs-dropdown vs-custom-content vs-trigger-click>
						<b-link href.prevent class="card-header-action btn-setting" style="font-size: 25px;">
							<b-button class="fa fa-th mr-2" variant="dark"
								style="padding: 8px;margin-top: -3px;width: 40px ;height: 35px"></b-button>
						</b-link>
						<vs-dropdown-menu class="columns-dropdown">
							<vs-dropdown-item v-for="(ind, i) in fields" :key="i">
								<b-checkbox v-model="ind.visible">{{ ind.label }}</b-checkbox>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</b-col>
			</b-row>
			<hr class="mt-1">
		</div>
		<b-card-body class="marginPage" id="print_certificate">
			<b-row>
				<b-col cols="3">
					<div style="font-size: 10px">DutyFree International</div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6><b>Отчет по валютам за период* {{ $t("c") }} {{ fromDate ? fromDate : '________' }} {{ $t("po")
							}}
							{{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
				<b-col>
					<!--					<download-excel :data="items" :fields="json_to_excel" :disabled="loading" style="cursor: pointer" class="btn btn-outline-primary" name="Продажи по группам">-->
					<!--						<b-spinner v-if="loading" small class="mr-2"/><strong>{{$t('excel-export.download-excel')}}</strong>-->
					<!--					</download-excel>-->
				</b-col>
			</b-row>
			<b-row class="mt-2">
				<b-col>
					<b v-if="allDep" style="font-size: 12px">{{ $t("Whole_firm") }}</b>
					<span v-else-if="depNames.length">{{ $t('pricing.department') }}: <b v-for="name in depNames"
							class="mr-2">{{ name }}</b></span>
					<b v-else>____________</b>
				</b-col>
			</b-row>
			<b-row class="mt-4">
				<b-col>
					<b-table :items="items" id="gridContainer" :fields="computedFields" :busy="loading"
						:responsive="true" small bordered show-empty striped hover foot-clone no-footer-sorting
						label-sort-asc="" label-sort-desc="" label-sort-clear="">
						<template #table-busy>
							<div class="text-center my-2">
								<b-spinner small class="mr-2" /><strong>Loading...</strong>
							</div>
						</template>
						<template #cell(index)="data">
							{{ data.index + 1 }}
						</template>
						<template #cell(date)="data">
							{{ data.item[0].date }}
						</template>
						<template #cell(department)="data">
							{{ data.item[0].department }}
						</template>
						<template #cell(Sale_in_EUR)="data">
							<span v-for="tmp in data.item"
								v-if="tmp.currencyCode == 'EUR' && tmp.paymentCode == 'CASH'">{{
									tmp.value | currency({
										symbol:
											'', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
									}) }}</span>
						</template>
						<template #cell(Sale_in_USD)="data">
							<span v-for="tmp in data.item"
								v-if="tmp.currencyCode == 'USD' && tmp.paymentCode == 'CASH'">{{
									tmp.value | currency({
										symbol:
											'', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
									}) }}</span>
						</template>
						<template #cell(Sale_in_RUB)="data">
							<span v-for="tmp in data.item"
								v-if="tmp.currencyCode == 'RUB' && tmp.paymentCode == 'CASH'">{{
									tmp.value | currency({
										symbol:
											'', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
									}) }}</span>
						</template>
						<template #cell(Sale_in_GBP)="data">
							<span v-for="tmp in data.item"
								v-if="tmp.currencyCode == 'GBP' && tmp.paymentCode == 'CASH'">{{
									tmp.value | currency({
										symbol:
											'', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
									}) }}</span>
						</template>
						<template #cell(Sale_in_VISA)="data">
							<span v-for="tmp in data.item" v-if="tmp.paymentCode == 'VISA'">{{ tmp.value |
								currency({
									symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
								})
								}}</span>
						</template>
						<template #cell(Sale_in_HUMO)="data">
							<span v-for="tmp in data.item" v-if="tmp.paymentCode == 'HUMO'">{{ tmp.value |
								currency({
									symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
								})
								}}</span>
						</template>
						<template #cell(Sale_in_UZCARD)="data">
							<span v-for="tmp in data.item" v-if="tmp.paymentCode == 'UZCARD'">{{ tmp.value |
								currency({
									symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
								})
								}}</span>
						</template>
						<template #cell(Sale_in_UZUM)="data">
							<span v-for="tmp in data.item" v-if="tmp.paymentCode == 'UZUM'">{{ tmp.value |
								currency({
									symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
								})
								}}</span>
						</template>
						<template #cell(Sale_in_OSON)="data">
							<span v-for="tmp in data.item" v-if="tmp.paymentCode == 'OSON'">{{ tmp.value |
								currency({
									symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
								})
								}}</span>
						</template>
						<template #cell(Sale_in_CLICK)="data">
							<span v-for="tmp in data.item" v-if="tmp.paymentCode == 'CLICK'">{{ tmp.value |
								currency({
									symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
								})
								}}</span>
						</template>
						<template #cell(Sale_in_PAYME)="data">
							<span v-for="tmp in data.item" v-if="tmp.paymentCode == 'PAYME'">{{ tmp.value |
								currency({
									symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
								})
								}}</span>
						</template>
						<template #cell(Sale_in_ONEQR)="data">
							<span v-for="tmp in data.item" v-if="tmp.paymentCode == 'ONE_QR'">{{ tmp.value |
								currency({ symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' ' })
							}}</span>
						</template>
						<template #cell(Sale_in_UZS)="data">
							<span v-for="tmp in data.item"
								v-if="tmp.currencyCode == 'UZS' && tmp.paymentCode == 'CASH'">{{
									tmp.value | currency({
										symbol:
											'', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '
									}) }}</span>
						</template>

						<template #foot(index)>
							{{ "" }}
						</template>
						<template #foot(date)>
							{{ "" }}
						</template>
						<template #foot(department)="data">
							<b>{{ $t("Itogo") }}</b>
						</template>

						<template #foot(Sale_in_EUR)="data">
							<b>{{ sumSaleInEur | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>

						<template #foot(Sale_in_USD)="data">
							<b>{{ sumSaleInUSD | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_RUB)="data">
							<b>{{ sumSaleInRUB | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_GBP)="data">
							<b>{{ sumSaleInGBP | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_VISA)="data">
							<b>{{ sumSaleInVISA | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_HUMO)="data">
							<b>{{ sumSaleInHUMO | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_UZCARD)="data">
							<b>{{ sumSaleInUZCARD | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_UZUM)="data">
							<b>{{ sumSaleInUZUM | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_OSON)="data">
							<b>{{ sumSaleInOSON | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_CLICK)="data">
							<b>{{ sumSaleInCLICK | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_PAYME)="data">
							<b>{{ sumSaleInPAYME | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_ONEQR)="data">
							<b>{{ sumSaleInONEQR | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
						<template #foot(Sale_in_UZS)="data">
							<b>{{ sumSaleInUZS | currency({
								symbol: '', fractionCount: 2, symbolPosition: 'back',
								thousandsSeparator: ' '
							}) }}</b>
						</template>
					</b-table>
					<b-button v-if="items.length > 0" class="float-right mt-1 hidden-print"
						@click="excelExport1('gridContainer', 'Отчет по валютам')" variant="primary"
						:disabled="loading">{{
							$t('excel-export.download-excel') }}</b-button>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import { BTable, VBTable } from "bootstrap-vue";
import UsersService from "../../../services/users.sevice";
import { TokenService } from "../../../services/storage.service";
import ReportService from "./report.service";

export default {
	name: "Товарный отчет за период",
	components: { Multiselect, BTable },
	directives: { VBTable },
	data() {
		return {
			items: [],
			fields: [
				{ key: 'index', label: '№', class: 'text-center', visible: true },
				{ key: 'date', label: this.$t('Дата'), class: 'text-center', visible: true },
				{ key: 'department', label: this.$t('pricing.department'), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_EUR", label: this.$t("Sale_in_EUR"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_USD", label: this.$t("Sale_in_USD"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_RUB", label: this.$t("Sale_in_RUB"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_GBP", label: this.$t("Sale_in_GBP"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_VISA", label: this.$t("Sale_in_VISA"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_HUMO", label: this.$t("Sale_in_HUMO"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_UZCARD", label: this.$t("Sale_in_UZCARD"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_UZUM", label: this.$t("Sale_in_UZUM"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_OSON", label: this.$t("Sale_in_OSON"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_CLICK", label: this.$t("Sale_in_CLICK"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_PAYME", label: this.$t("Sale_in_PAYME"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_ONEQR", label: this.$t("Sale_in_ONEQR"), class: 'text-center', visible: true, sortable: true },
				{ key: "Sale_in_UZS", label: this.$t("Sale_in_UZS"), class: 'text-center', visible: true, sortable: true },
			],
			cols: [
				{ key: '', sortable: true }
			],
			fromDate: null,
			toDate: null,
			departments: [],
			departmentId: null,
			departmentName: '',
			allDep: false,
			loading: false,
			depIds: [],
			depNames: []
		};
	},
	methods: {
		getExcelItems() {
			this.loading = true
			if (this.fromDate && this.toDate) {
				if (this.departmentId || this.allDeps) {
					let data = {
						startDate: this.cur,
						endDate: this.toDate,
						deps: this.departmentId,
						allDeps: this.allDeps,
						groups: this.groupIds,
						subGroups: this.categoryIds,
						groupNots: this.groupNots,
						subGroupNots: this.subGroupNots,
						value: this.itemName,
						barcode: this.barcode
					}
					ReportService.getExcelItems1(data).then(res => {
						this.items = res.data
						this.loading = false
					}).catch(e => {
						this.loading = false
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else {
					this.loading = false
					this.$vs.notify({
						text: "Выберите Подразделение с периодом",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
					return 0;
				}
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		},
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function (s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function (s, c) {
					return s.replace(/{(\w+)}/g, function (m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		print() {
			const prtHtml = document.getElementById("print_certificate").innerHTML;
			let stylesHtml = "";
			for (let node of [
				...document.querySelectorAll('link[rel="stylesheet"], style'),
			]) {
				stylesHtml += node.outerHTML;
			}
			// Open the print window
			const WinPrint = window.open(
				"",
				"",
				"left=0,top=0,width=1000,height=1000,toolbar=0,scrollbars=0,status=0"
			);
			let html = `<!DOCTYPE html>
					<html>

					  <head>
					  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN" crossorigin="anonymous">
					  <style>
					body {
					  color: #000 !important;
					  align-items: flex-start;
					}
					#print_certificate {
					  display: block;
					}
					img.shadow {
					  box-shadow: none !important;
					}
					 table ,tr,td,th {
  						border: rgba(0,0,255,0.25) solid !important;
					}
					table {
             			border-collapse: collapse !important;
            		}
					</style>
						${stylesHtml}
					  </head>
					  <body>
						${prtHtml}

					  </body>
					</html>`;
			WinPrint.document.write(html);
			WinPrint.print();
		},
		getItems() {
			this.loading = true
			this.items = []
			if (this.depIds.length > 0 && this.fromDate && this.toDate) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate,
					depId: this.depIds[0]
				}
				ReportService.getReportItems12Test(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {
		this.getDeps();
	},
	computed: {
		computedFields() {
			let tmp = []
			this.fields.forEach(t => {
				if (t.visible)
					tmp.push(t)
			})
			return tmp
		},
		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		},
		sumSaleInEur() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.currencyCode == 'EUR' && k.paymentCode == 'CASH')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},
		sumSaleInUSD() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.currencyCode == 'USD' && k.paymentCode == 'CASH')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},
		sumSaleInRUB() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.currencyCode == 'RUB' && k.paymentCode == 'CASH')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},
		sumSaleInGBP() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.currencyCode == 'GBP' && k.paymentCode == 'CASH')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},

		sumSaleInVISA() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.paymentCode == 'VISA')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},

		sumSaleInHUMO() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.paymentCode == 'HUMO')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},

		sumSaleInUZUM() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.paymentCode == 'UZUM')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},

		sumSaleInOSON() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.paymentCode == 'OSON')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},

		sumSaleInCLICK() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.paymentCode == 'CLICK')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},
		sumSaleInPAYME() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.paymentCode == 'PAYME')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},
		sumSaleInONEQR() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.paymentCode == 'ONE_QR')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},
		sumSaleInUZCARD() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.paymentCode == 'UZCARD')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},
		sumSaleInUZS() {
			let sum = 0
			this.items.forEach(t => {
				t.forEach(k => {
					if (k.currencyCode == 'UZS' && k.paymentCode == 'CASH')
						sum = sum + Number(parseFloat(k.value.toFixed(2)))
				})
			})
			return sum;
		},

	},
	watch: {
		'departmentId': {
			handler(newValue) {
				this.depIds = [newValue.id]
				this.depNames = [newValue.name]
				// newValue.forEach(res => {
				// 	this.depIds.push(res.id)
				// 	this.depNames.push(res.name)
				// })
			}
		},
		'allDep': {
			handler(res) {
				if (res) {
					this.depIds = []
					this.departments.forEach(r => {
						this.depIds.push(r.id)
					})
				}
			}
		}
	}
}
</script>

<style scoped>
@page {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}

	.marginPage {
		margin: 0 30px 0 40px;
	}
}
</style>
